import type { SearchSuggestion } from '../../../app/components/SearchBar/SearchBarAutocomplete';
import type { SearchHit, SearchListResponse } from './types';
import { esLang } from './types';

export function unwrapSearchData(response: unknown): SearchListResponse {
  if (
    response &&
    typeof response === 'object' &&
    'data' in response &&
    (response as { data: unknown }).data
  ) {
    return (response as { data: SearchListResponse }).data;
  }
  return response as SearchListResponse;
}

export function mapHitToSuggestion(
  hit: SearchHit,
  _categoryLabel?: string,
): SearchSuggestion {
  return {
    id: hit.id ?? `${hit.category?.key ?? 'hit'}-${hit.code}`,
    title: hit.title,
    subTitle: hit.subTitle,
    category: hit.category,
    description: hit.description,
    link: hit.link,
  };
}

export function resolveI18nTitle(
  hit: SearchHit,
  appLang: string,
): string {
  const lang = esLang(appLang);
  return hit.title?.[lang] || hit.title?.en || hit.slug || '';
}
